'use client';

import Image from 'next/image';

import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './AcneProject.styles';

export function AcneProject() {
  const slots = styles();

  return (
    <div
      className={slots.base()}
      id="social-project"
    >
      <div className={slots.content()}>
        <div className={slots.info()}>
          <Image
            width={324}
            height={150}
            src={staticMediaUrl('landing/bioderma_sebium/logo-acne.svg')}
            alt="Социальный проект бренда BIODERMA"
            className={slots.logo()}
          />
          <p className={slots.text()}>
            Социальный проект бренда BIODERMA, созданный при участии{' '}
            <span className={slots.strong()}>150+ врачей-экспертов</span> для
            поддержки людей с кожей, склонной к акне
          </p>
          <UiKitButtonBase
            className={slots.buttonDesktop()}
            href="http://acneproject.naos.ru/"
            as="link"
            target="_blank"
          >
            Узнайте больше о проекте
          </UiKitButtonBase>
        </div>

        <div className={slots.advantages()}>
          <div className={slots.advantage()}>
            <Image
              width={72}
              height={72}
              src={staticMediaUrl('landing/bioderma_sebium/advantage1_1.png')}
              alt="Советы экспертов по уходу за кожей"
              className={slots.advantageImage()}
            />
            <p className={slots.advantageText()}>
              Советы экспертов
              <br /> по уходу за кожей​
            </p>
          </div>
          <div className={slots.advantage()}>
            <Image
              width={72}
              height={72}
              src={staticMediaUrl('landing/bioderma_sebium/advantage2_1.png')}
              alt="Помощь в подборе дерматолога и записи на первый приём"
              className={slots.advantageImage()}
            />
            <p className={slots.advantageText()}>
              Помощь в подборе дерматолога
              <br className={slots.br()} /> и&nbsp;записи
              на&nbsp;первый&nbsp;приём​
            </p>
          </div>
          <div className={slots.advantage()}>
            <Image
              width={72}
              height={72}
              src={staticMediaUrl('landing/bioderma_sebium/advantage3_1.png')}
              alt="Обучающие лекции для подростков"
              className={slots.advantageImage()}
            />
            <p className={slots.advantageText()}>
              Обучающие лекции
              <br /> для подростков
            </p>
          </div>
        </div>

        <UiKitButtonBase
          className={slots.buttonMobile()}
          href="http://acneproject.naos.ru/"
          as="link"
          target="_blank"
        >
          Узнайте больше о проекте
        </UiKitButtonBase>
      </div>

      <div className={slots.visual()}>
        <picture>
          <source
            srcSet={staticMediaUrl(
              'landing/bioderma_sebium/acne-visual_sm.png'
            )}
            media="(max-width: 767px)"
          />
          <img
            className={slots.image()}
            src={staticMediaUrl('landing/bioderma_sebium/acne-visual1.png')}
            alt="#ЛечимАкнеВместе"
          />
        </picture>
      </div>
    </div>
  );
}
